import React from 'react'
import Tooltip from 'antd/lib/tooltip'
import { EffectiveCapacity } from './utils'

interface CapacityUseCellProps {
  capacity: EffectiveCapacity
}

// Shared by the modifier and variant inventory tables, which each render a
// pickup and a delivery capacity use column.
const CapacityUseCell = ({ capacity }: CapacityUseCellProps) =>
  capacity.value === null ? (
    <Tooltip title='No capacity weight set.'>
      <span>-</span>
    </Tooltip>
  ) : (
    <Tooltip title={`Source: ${capacity.source}`}>
      <span>{capacity.value}</span>
    </Tooltip>
  )

export default CapacityUseCell
